import { firebase } from "@firebase/app";
import "@firebase/analytics";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/storage";


const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBhejty3KIkqz0Nsa4iSmdhUTHTp938Dt0",
  authDomain: "meditatio-cd.firebaseapp.com",
  databaseURL: "https://meditatio-cd.firebaseio.com",
  projectId: "meditatio-cd",
  storageBucket: "meditatio-cd.appspot.com",
  messagingSenderId: "424983318382",
  appId: "1:424983318382:web:02d164eb1ebdee676ffb7f",
  measurementId: "G-0SHV7R9J73"
});

firebase.analytics();

export const analytics = firebase.analytics();
export const db = firebaseApp.firestore();
export const storage = firebaseApp.storage();

